// extracted by mini-css-extract-plugin
export default {"host":"styles_host__Dxcoy","main":"styles_main__OrN03","formButtons":"styles_formButtons__sYVEZ"};